export const fieldMapping = {
    aglutinator: [{ section: 'LeadInfoCard', field: 'aglutinator' }],
    origen_it: [{ section: 'LeadInfoCard', field: 'origen_it' }],
    campaigns: [{ section: 'LeadInfoCard', field: 'campaigns' }],
    interes_original: [{ section: 'LeadInfoCard', field: 'interes_original' }],
    created_time: [{ section: 'LeadInfoCard', field: 'created_time' }],
    full_name: [
        { section: 'LeadInfoCard', field: 'full_name' },
        { section: 'SalesForm', field: 'full_name' }
    ],
    client_type: [{ section: 'SalesForm', field: 'client_type' }],
    cups: [{ section: 'SalesForm', field: 'cups' }],
    nif: [{ section: 'SalesForm', field: 'nif' }],
    phone: [{ section: 'SalesForm', field: 'phone' }],
    email: [{ section: 'SalesForm', field: 'email' }],
    address_full: [{ section: 'SalesForm', field: 'address_full' }],
    iban: [{ section: 'SalesForm', field: 'iban' }],
    potencia_p1: [{ section: 'SalesForm', field: 'potencia_p1' }],
    potencia_p2: [{ section: 'SalesForm', field: 'potencia_p2' }],
    potencia_p3: [{ section: 'SalesForm', field: 'potencia_p3' }],
    potencia_p4: [{ section: 'SalesForm', field: 'potencia_p4' }],
    potencia_p5: [{ section: 'SalesForm', field: 'potencia_p5' }],
    potencia_p6: [{ section: 'SalesForm', field: 'potencia_p6' }],
    province: [{ section: 'SalesForm', field: 'province' }],
    town: [{ section: 'SalesForm', field: 'town' }],
    cae: [{ section: 'SalesForm', field: 'cae' }],
    is_autonomo: [{ section: 'SalesForm', field: 'is_autonomo' }],
    tarifa_id: [{ section: 'SalesForm', field: 'tarifa_id' }],
    postal_code: [{ section: 'SalesForm', field: 'postal_code' }],
    scoring_result: [{ section: 'SalesForm', field: 'scoring_result' }],
    scoring_detail: [{ section: 'SalesForm', field: 'scoring_detail' }],
    // Missing fields
    aclarador_finca: [{ section: 'SalesForm', field: 'aclarador_finca' }],
    direccion_suministro_distinta: [{ section: 'SalesForm', field: 'direccion_suministro_distinta' }],
    address_suministro_full: [{ section: 'SalesForm', field: 'address_suministro_full' }],
    aclarador_finca_suministro: [{ section: 'SalesForm', field: 'aclarador_finca_suministro' }],
    province_suministro: [{ section: 'SalesForm', field: 'province_suministro' }],
    town_suministro: [{ section: 'SalesForm', field: 'town_suministro' }],
    postal_code_suministro: [{ section: 'SalesForm', field: 'postal_code_suministro' }],
    tipo_via_cnmc: [{ section: 'SalesForm', field: 'tipo_via_cnmc' }],
    tipo_via_titular_cnmc: [{ section: 'SalesForm', field: 'tipo_via_titular_cnmc' }],
    es_alta_nueva: [{ section: 'SalesForm', field: 'es_alta_nueva' }],
    mismo_titular: [{ section: 'SalesForm', field: 'mismo_titular' }],
    misma_potencia: [{ section: 'SalesForm', field: 'misma_potencia' }],
    no_credit_check: [{ section: 'SalesForm', field: 'no_credit_check' }],
    tipo_autoconsumo_cnmc: [{ section: 'SalesForm', field: 'tipo_autoconsumo_cnmc' }],
    inicio_contrato: [{ section: 'SalesForm', field: 'inicio_contrato' }],
    fecha_inicio: [{ section: 'SalesForm', field: 'fecha_inicio' }],
    canal_envio: [{ section: 'SalesForm', field: 'canal_envio' }],
    mandar_a_firma: [{ section: 'SalesForm', field: 'mandar_a_firma' }],
    fecha_firma_datos: [{ section: 'SalesForm', field: 'fecha_firma_datos' }],
    // Contract Callback Fields
    contract_code: [{ section: 'SalesForm', field: 'contract_code' }],
    contract_status: [{ section: 'SalesForm', field: 'contract_status' }],
    credit_status: [{ section: 'SalesForm', field: 'credit_status' }],
    firma_status: [{ section: 'SalesForm', field: 'firma_status' }],
    callback_received_at: [{ section: 'SalesForm', field: 'callback_received_at' }],
    submit_error: [{ section: 'SalesForm', field: 'submit_error' }]
};
